export const FEATURES = {
  OPS_MASKED_PHONE_NUMBERS: 'ops_masked_phone_numbers',
  RELEASE_BUYER_APPLICATION_AUTH_REMOVAL:
    'release_buyer_application_auth_removal',
  REL_BNPL_TOGGLE: 'rel_bnpl_toggle',
  REL_DETAILS_TAB: 'rel_details_tab',
  REL_CONTRACTS_V2: 'rel_contracts_v2',
  REL_PUPPY_PREFERENCE: 'rel_puppy_preference',
  REL_MOVE_LITTER_TO_PAST_MODAL: 'rel_move_litter_to_past_modal',
  REL_BREEDER_PAYMENT_ENFORCEMENT: 'rel_breeder_payment_enforcement',
  REL_LITTER_GROUP_MESSAGING: 'rel_litter_group_messaging',
  REL_WEB_UI_LITTER_GROUP_MESSAGING: 'rel_web_ui_litter_group_messaging',
  REL_GETTING_YOUR_PUPPY: 'rel_getting_your_puppy',
  REL_OWNER_HUB: 'rel_owner_hub',
  REL_SHARED_PICKUP_PLAN: 'rel_shared_pickup_plan'
};
